let timeWhenCheckWasSent;

const dataObject = {
	login() {
		return axios.post('/api/auth/login').then(response => {
			localStorage.setItem('auth_token', response.data.token);
			axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');

		}).catch(error => {
			console.log(error);
		});
	},
	logout() {
		return axios.post('/api/auth/logout').then(response => {
			localStorage.removeItem('auth_token');
			localStorage.removeItem('vuex');
			axios.defaults.headers.common['Authorization'] = null;
		}).catch(error => {
			console.log(error);
		});
	},

	check() {
		timeWhenCheckWasSent = new Date().getTime();

		return axios.post('/api/auth/check').then(response => {
			timeWhenCheckWasSent = new Date().getTime();
			return !!response.data.authenticated;
		}).catch(error => {
			window.location.reload();
		});
	},

	getUserAccountsInfo() {
		return axios.get('/api/user/accounts').then(response => {
			return response.data;
		}).catch(error => {
			console.log(error);
		});
	},
	// validateCard(paymentMethodId, cvv) {
	//     return axios.post('/api/validate-card', {
	//         paymentMethodId: paymentMethodId,
	//         cvv: cvv,
	//     }).then(response => {
	//         return response.data;
	//     }).catch(error => {
	//         console.log(error);
	//     });
	// },
	validateCardAndCreatePayment(paymentMethodId, cvv, amount) {
		return axios.post('/api/validate-card-and-make-payment', {
			paymentMethodId: paymentMethodId,
			cvv: cvv,
			amount: amount
		})
			.then(response => response)
			.catch(error => error);
	},
	createCardAndMakePayment(nameOnCard, pan, cvv, expiryYear, expiryMonth, amount, addressId, setAsDefaultPaymentMethodForFuture = true) {
		return axios.post('api/create-card-and-make-payment', {
			nameOnCard: nameOnCard,
			pan: pan,
			cvv: cvv,
			expiryYear: expiryYear,
			expiryMonth: expiryMonth,
			amount: amount,
			addressId: addressId,
			setAsDefaultPaymentMethodForFuture: setAsDefaultPaymentMethodForFuture,
		}).then(response => {
			console.log('response', response);
			return response;
		}).catch(error => {
			console.log('error', error);
		});
	}
};

// window['checkInterval'] = setInterval(() => {
// 	let currentTime = new Date().getTime();
//
// 	if (!timeWhenCheckWasSent) {
// 		timeWhenCheckWasSent = currentTime;
// 		return;
// 	}
//
// 	let targetTime = Math.round((currentTime - timeWhenCheckWasSent)/1000);
//
// 	if (targetTime > 120) {
// 		dataObject.check();
// 	}
// }, 2000);

export default dataObject;
